export default __webpack_public_path__ + "static/media/IMG_165.84e717ea.jpg";